module.exports = __webpack_public_path__ + "static/media/Acrilico (31).c9746a48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Acrilico/Acrilico (31).jpg
// module id = 299
// module chunks = 0